import React from 'react';

interface V5GadgetFormContextType {
  isEditing: boolean;
  series: V5ChartDefinitionSeries[];
  setSeries: React.Dispatch<React.SetStateAction<V5ChartDefinitionSeries[]>>;
  dimensionA?: Dimension;
  setDimensionA: React.Dispatch<React.SetStateAction<Dimension | undefined>>;
  secondaryDimensionA?: Dimension;
  setSecondaryDimensionA: React.Dispatch<
    React.SetStateAction<Dimension | undefined>
  >;
  isSecondaryDimensionAAvailable: boolean;
  dimensionB?: Dimension;
  setDimensionB: React.Dispatch<React.SetStateAction<Dimension | undefined>>;
  stackedBarOptions: StackedBarOptions | undefined;
  setStackedBarOptions: (opts: StackedBarOptions) => void;
  stackedAreaOptions: StackedAreaOptions | undefined;
  setStackedAreaOptions: (opts: StackedAreaOptions) => void;
  draftChart?: V5ChartDefinition;
  isLoading: boolean;
  selectedSource?: GadgetSource;
  onSave?: () => void;
  onSaveAs?: () => void;
  onDelete?: () => void;
  isDimensionalChart: boolean;
  isMultipleDimensionChart: boolean;
  isMultipleSeriesChart: boolean;
  isMultipleYAxisChart: boolean;
  showDataLabels?: boolean;
  setShowDataLabels: React.Dispatch<React.SetStateAction<undefined | boolean>>;
  labelStep?: number;
  setLabelStep: React.Dispatch<React.SetStateAction<number | undefined>>;
  reverseAxes?: boolean;
  setReverseAxes: React.Dispatch<React.SetStateAction<boolean>>;
  isSecondaryRowsStacked?: boolean;
  setIsSecondaryRowsStacked: React.Dispatch<React.SetStateAction<boolean>>;
  totalsColumnPosition?: 'first' | 'last';
  setTotalsColumnPosition: React.Dispatch<
    React.SetStateAction<'first' | 'last'>
  >;
  groupByLimitMode: 'top n' | ExcludeTopN | 'show all' | undefined;
  setGroupByLimitMode: React.Dispatch<
    React.SetStateAction<'top n' | ExcludeTopN | 'show all' | undefined>
  >;
  setGroupByLimit: React.Dispatch<React.SetStateAction<number | undefined>>;
}

const V5GadgetFormContext = React.createContext<V5GadgetFormContextType>({
  isEditing: false,
  series: [],
  setSeries: () => {},
  setDimensionA: () => {},
  setSecondaryDimensionA: () => {},
  isSecondaryDimensionAAvailable: false,
  setDimensionB: () => {},
  stackedBarOptions: undefined,
  setStackedBarOptions: () => {},
  stackedAreaOptions: undefined,
  setStackedAreaOptions: () => {},
  draftChart: {
    id: '',
    name: '',
    gadgetType: 'bar',
    series: [],
  },
  isLoading: false,
  isDimensionalChart: false,
  isMultipleDimensionChart: false,
  isMultipleSeriesChart: false,
  isMultipleYAxisChart: false,
  showDataLabels: false,
  setShowDataLabels: () => {},
  labelStep: undefined,
  setLabelStep: () => {},
  reverseAxes: false,
  setReverseAxes: () => {},
  isSecondaryRowsStacked: false,
  setIsSecondaryRowsStacked: () => {},
  totalsColumnPosition: 'last',
  setTotalsColumnPosition: () => {},
  groupByLimitMode: undefined,
  setGroupByLimitMode: () => {},
  setGroupByLimit: () => {},
});

export default V5GadgetFormContext;
